import React, {Component} from "react";
import {withTranslate} from "react-redux-multilingual"


class ProfileSidebar extends Component {
    state = {
        showErrorSweetAlert: false,
        showRequestSweetAlert: false,
        reservation: null,
        isRemovingReservationFromList: false,
        currentReservationInPage: null,
    };

/*    componentDidMount() {
        this.props.getUpcomingReservations();
    }

    cancelReservationSweetAlert = (reservation) => {
        this.setState({
            showRequestSweetAlert: true,
            reservation
        });
    };

    rescheduleReservation = (reservation) => {
        window.localStorage.setItem("rescheduleReservation", JSON.stringify(reservation));
        window.location.href = "/doctor/" + reservation.doctor.unique_id;
    };
    handleCancelReservation = (reservation) => {
        this.setState({
            isRemovingReservationFromList: true,
        });
        axios.post(cancelReservationLink, {
            reservation_id: reservation.id,
            status: 2
        }, {headers: getHeader()}).then(res => {
            this.setState({
                showRequestSweetAlert: false,
                isRemovingReservationFromList: false,
            });
            if (res.data.Error.code === 20) {
                this.props.removeReservationFromList(reservation);
                this.setState({
                    currentReservationInPage: this.props.upcomingReservations && this.props.upcomingReservations.length ? this.props.upcomingReservations[0] : null,
                });
            } else {
                this.setState({
                    showErrorSweetAlert: true
                })
            }
        }).catch(err => {
            this.setState({
                showErrorSweetAlert: true
            })
        });
    };

    handlePages = (reservation) => {
        this.setState({
            currentReservationInPage: reservation
        })
    };*/

    render() {
/*
       const {upcomingReservations, upcomingReservationsIsLoading} = this.props;
        const allUpcomingReservations = upcomingReservations && upcomingReservations.length ? upcomingReservations.map((reservation, index) => {
            if (!this.state.currentReservationInPage && index === 0)
                this.setState({
                    currentReservationInPage: reservation
                });

            return (
                <div className="profile-reservations-details shadow-4d relative"
                     hidden={this.state.currentReservationInPage && (this.state.currentReservationInPage.id !== reservation.id)}
                     key={index}>
                    <AppointmentCard cancelReservationSweetAlert={() => this.cancelReservationSweetAlert(reservation)}
                                     rescheduleReservation={() => this.rescheduleReservation(reservation)}
                                     currentReservation={reservation}/>

                </div>

            )
        }) : <div className="margin-top-30"><NoData image="no-appointments"/></div>;


        const pages = upcomingReservations && upcomingReservations.length ? upcomingReservations.map((reservation, index) => {
            return (
                <div onClick={() => this.handlePages(reservation)}
                     className={reservation && this.state.currentReservationInPage && (reservation.id === this.state.currentReservationInPage.id) ? "cursor-pointer active" : "cursor-pointer"}>
                </div>
            )
        }) : null;

*/

        return (
            <div className="profile-reservations-card mt-45">
               {/* <SweetAlert
                    show={this.state.showRequestSweetAlert}
                    title={this.props.translate("are_you_sure_ques")}
                    confirmRequestPlanBtnText={this.props.translate("ok")}
                    onConfirm={() => this.handleCancelReservation(this.state.reservation)}
                    showCancel
                    cancelBtnBsStyle="sweet custom-danger"
                    confirmBtnBsStyle="sweet success-sweet"
                    onCancel={() => this.setState({showRequestSweetAlert: false})}>
                    {this.props.translate("cancel_reservation")}
                    <img src="../images/loading.svg" alt="loading" className="width-50"
                         hidden={!this.state.isRemovingReservationFromList}/>
                </SweetAlert>*/}
                <div className="side-bar-branch">
                    <div className="branch">
                        <div className="branch-header text-center">
                            <h5>{this.props.translate("completed")}</h5>
                        </div>
                    </div>

                    <div className="completed-profile margin-top-30">
                        <div className="set-size charts-container">
                            <div className={"pie-wrapper progress-" + this.props.profile.completed}>
                                <span className="label">{this.props.profile.completed}<span className="smaller">%</span></span>
                                <div className="pie">
                                    <div className="left-side half-circle"></div>
                                    <div className="right-side half-circle"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslate(ProfileSidebar)
